import {
  FooterType,
  LayoutType,
  MenuStyle,
  NavStyle,
  ThemeDirection,
  ThemeMode,
  ThemeStyle,
} from '../../../shared/constants/AppEnums';

// The design's light shell: a white sidebar, labels in its grey, the chosen
// entry in ink (painted in shared/styles/brand.less).
export const LightSidebar = {
  sidebarBgColor: '#ffffff',
  sidebarTextColor: '#535358',
  sidebarHeaderColor: '#ffffff',
  sidebarMenuSelectedBgColor: '#eeeef9',
  sidebarMenuSelectedTextColor: '#080121',
  mode: ThemeMode.LIGHT,
};

const defaultConfig = {
  sidebar: {
    borderColor: '#757575',
    menuStyle: MenuStyle.STANDARD,
    isSidebarBgImage: false,
    sidebarBgImage: 1,
    colorSet: LightSidebar,
    sidebarMenuSelectedColor: LightSidebar.sidebarMenuSelectedBgColor,
  },
  locale: {
    code: 'en',
    name: 'English',
    icon: 'uk',
  },
  themeStyle: ThemeStyle.MODERN,
  direction: ThemeDirection.LTR,
  themeMode: ThemeMode.LIGHT,
  footerType: FooterType.FLUID,
  navStyle: NavStyle.MINI_SIDEBAR_TOGGLE,
  layoutType: LayoutType.FULL_WIDTH,
  footer: true,
  rtlLocale: ['ar'],
};
export default defaultConfig;
